export default "__VITE_ASSET__DuBiL9fe__"